import { h } from "preact";

export default function FilterBar({ children }) {
  return (
    <div class="filterBar">
      <div class="filterBar__inner">{children}</div>
    </div>
  );
}
